const article = {
    slug: "yohji-yamamoto",
    category: "BRAND BUYBACK",
    listTitle: "YOHJI YAMAMOTO買取",
    listDescription:
      "YOHJI YAMAMOTO POUR HOMME、Y's、Ground Y、S'YTE、アーカイブ作品まで、ヨウジヤマモトの黒・ドレープ・カッティングの価値を見て査定する専用買取ページ。",
    seo: {
      title:
        "YOHJI YAMAMOTO買取｜ヨウジヤマモトのアーカイブ価値まで査定するEnclopedia",
      description:
        "YOHJI YAMAMOTO（ヨウジヤマモト）の買取ならEnclopediaへ。YOHJI YAMAMOTO POUR HOMME、Y's、Ground Y、S'YTE、ジャケット、コート、パンツ、シャツ、ドレープ、ウールギャバ、アーカイブ作品まで、シーズン背景・造形性・希少性・市場価値を見て査定。LINE事前査定から全国対応の宅配買取へご案内します。",
      keyword:
        "YOHJI YAMAMOTO 買取,ヨウジヤマモト 買取,Yohji Yamamoto 買取,ヨウジヤマモト 高価買取,YOHJI YAMAMOTO 高価買取,YOHJI YAMAMOTO 宅配買取,ヨウジヤマモト 宅配買取,YOHJI YAMAMOTO LINE査定,ヨウジヤマモト 買取相場,YOHJI YAMAMOTO アーカイブ 買取,ヨウジヤマモト アーカイブ 買取,YOHJI YAMAMOTO POUR HOMME 買取,ヨウジヤマモト プールオム 買取,Y's 買取,ワイズ 買取,Y's for men 買取,Ground Y 買取,グラウンドワイ 買取,S'YTE 買取,サイト 買取,ウールギャバ 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/yohji-yamamoto",
    },
    hero: {
      label: "YOHJI YAMAMOTO BUYBACK",
      number: "10 / BUYBACK",
      titleLines: [
        "YOHJI YAMAMOTO買取。",
        "黒と余白の価値まで見て査定します。",
      ],
      body:
        "Enclopediaは、YOHJI YAMAMOTOをブランド名や型番だけで一律に判断しません。\nYOHJI YAMAMOTO POUR HOMME、Y's、Ground Y、S'YTE、過去シーズンのアーカイブまで、黒、ドレープ、カッティング、ウールギャバ、シルエット、シーズン背景、現在の需要を確認し、個々のアイテムにフォーカスして査定します。\nまずはLINEで無料の事前査定。納得いただけた方を、全国対応の宅配買取へご案内します。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "yohji yamamoto buyback",
        "black tailoring",
        "archive valuation",
        "drape silhouette",
      ],
      visualLabel: "ARCHIVE VALUATION",
      visualTitle: [
        "黒い服としてではなく、",
        "余白をまとう服として見る。",
      ],
      image: "media/archive_fashion/buyback10.png",
      imageAlt: "YOHJI YAMAMOTO買取のメイン画像",
    },
    thesis: {
      text:
        "YOHJI YAMAMOTOの価値は、ブランド名だけでなく、黒・布量・ドレープ・カッティング・シーズン背景まで見て判断する。",
      keywords: ["black", "drape", "archive rarity"],
    },
    intro: {
      label: "02 / OUR BUYBACK VIEW",
      titleLines: [
        "YOHJI YAMAMOTOの価値は、",
        "“黒い服”だけでは測れない。",
      ],
      body:
        "YOHJI YAMAMOTOは、黒、余白、非対称、布量、ドレープ、身体との距離感によって、服の見え方そのものを変えてきたブランドです。\n同じ黒のジャケットでも、ウールギャバの落ち感、肩線、着丈、分量、シーズンテーマによって価値は大きく変わります。\nEnclopediaでは、単にヨウジヤマモトというブランド名だけでなく、その一着がどのラインに属し、どのような造形と時代性を持つかまで確認して査定します。",
    },
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: [
        "Enclopediaが重視する、",
        "3つの査定視点。",
      ],
      items: [
        {
          number: "01",
          title: "黒と素材の表情を見る",
          text:
            "ウールギャバ、リネン、レーヨン、コットン、レザーなど、素材ごとの落ち感・重さ・経年状態を確認します。",
        },
        {
          number: "02",
          title: "シルエットとカッティングを見る",
          text:
            "ロング丈、ワイドパンツ、ドレープ、アシンメトリー、変形パターンなど、YOHJI YAMAMOTOらしい身体との距離感を見ます。",
        },
        {
          number: "03",
          title: "ラインと希少性を見る",
          text:
            "POUR HOMME、Y's、Y's for men、Ground Y、S'YTEなど、ラインごとの需要とアーカイブ性を分けて判断します。",
        },
      ],
    },
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: [
        "YOHJI YAMAMOTO全般を、",
        "幅広く査定します。",
      ],
      items: [
        {
          tag: "ITEM 01",
          title: "YOHJI YAMAMOTO POUR HOMME",
          text:
            "ジャケット、コート、パンツ、シャツ、ニット、セットアップなど、メンズラインのアーカイブ性が強い品を査定します。",
        },
        {
          tag: "ITEM 02",
          title: "YOHJI YAMAMOTO / Femme",
          text:
            "ドレス、ジャケット、コート、スカート、パンツなど、ウィメンズの造形性が高い作品も丁寧に見ます。",
        },
        {
          tag: "ITEM 03",
          title: "Y's / Y's for men",
          text:
            "日常性とヨウジらしい余白を持つY's、廃止ラインを含むY's for menも、年代と需要を踏まえて査定します。",
        },
        {
          tag: "ITEM 04",
          title: "Ground Y / S'YTE",
          text:
            "比較的新しいラインも査定対象です。人気型、状態、サイズ、現在需要を確認して個別に判断します。",
        },
        {
          tag: "ITEM 05",
          title: "ウールギャバ・定番ジャケット",
          text:
            "ヨウジヤマモトを象徴するウールギャバのジャケット、コート、パンツ、セットアップを丁寧に確認します。",
        },
        {
          tag: "ITEM 06",
          title: "ワイドパンツ・サルエル・袴パンツ",
          text:
            "布量、落ち感、シルエットの美しさが価値に直結しやすいボトムス類も査定対象です。",
        },
        {
          tag: "ITEM 07",
          title: "プリント・刺繍・メッセージ系アイテム",
          text:
            "シーズン性の強いプリント、刺繍、手書き風グラフィック、メッセージ性のある作品は個別に価値を見ます。",
        },
        {
          tag: "ITEM 08",
          title: "過去シーズンのアーカイブ",
          text:
            "古いだけで高くなるわけではありませんが、現在も評価されるシルエットや希少性のある作品はアーカイブ価値まで見ます。",
        },
      ],
    },
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: [
        "高価買取につながりやすい、",
        "YOHJI YAMAMOTOのアイテム。",
      ],
      intro:
        "査定額は状態や市場性で変動しますが、Enclopediaでは特に以下のようなYOHJI YAMAMOTOを丁寧に確認します。",
      items: [
        {
          index: "01",
          title: "POUR HOMMEのジャケット・コート・セットアップ",
          text:
            "YOHJI YAMAMOTO POUR HOMMEの中でも、シルエットが美しいテーラード、ロングコート、セットアップは需要を確認して評価します。",
        },
        {
          index: "02",
          title: "ウールギャバを用いた定番・名作アイテム",
          text:
            "ヨウジヤマモトらしい落ち感と黒の深さが出るウールギャバのアイテムは、状態・年代・型を丁寧に見ます。",
        },
        {
          index: "03",
          title: "ワイドパンツ・袴パンツ・サルエルパンツ",
          text:
            "身体のバランスを変えるボトムスは、ヨウジらしさが強く、サイズや状態次第で評価につながりやすい領域です。",
        },
        {
          index: "04",
          title: "シーズンテーマを象徴するプリント・刺繍作品",
          text:
            "一見扱いが難しいグラフィックやメッセージ性のある作品も、コレクション文脈と需要を見て個別に判断します。",
        },
        {
          index: "05",
          title: "Y's for menなどの希少アーカイブ",
          text:
            "廃止ラインや流通量の少ない過去作は、年代だけでなく、現在も着用価値があるかまで確認します。",
        },
      ],
    },
    quote: {
      textLines: [
        "“黒い服”としてではなく、",
        "余白と身体の関係を変える服として見る。",
      ],
    },
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: [
        "一般的な査定で、",
        "見落とされやすいYOHJI YAMAMOTOの価値。",
      ],
      intro:
        "YOHJI YAMAMOTOは、同じ黒・同じジャケットでも、素材、分量、カッティング、年代、ラインによって評価が大きく変わるブランドです。",
      items: [
        {
          index: "01",
          title: "黒い服を一括で見ない",
          text:
            "ヨウジの黒は、素材、落ち感、陰影、布量によって印象が変わります。単なる色ではなく、造形として確認します。",
        },
        {
          index: "02",
          title: "定番品を型番だけで終わらせない",
          text:
            "ジャケット、パンツ、コートも、肩線、着丈、分量、素材、シーズン性によって価値が変わります。",
        },
        {
          index: "03",
          title: "着用価値とアーカイブ性をあわせて見る",
          text:
            "Enclopediaはアーカイブのレンタル・共有を行うため、次の着用者へ渡る価値があるかという視点も持って査定します。",
        },
      ],
    },
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: [
        "LINE事前査定から、",
        "宅配買取へ。",
      ],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "写真と簡単な情報をお送りください。全体、ブランドタグ、品番タグ、素材表記、汚れやダメージ箇所が分かる写真があると確認しやすくなります。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "本査定をご希望の場合は申込フォームへ。宅配キットの要否もここで選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。コートやセットアップなど重量のあるアイテムも、ご自身の箱または選択制の宅配キットでお送りいただけます。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後に状態・真贋・市場性・アーカイブ価値を確認。金額にご納得いただければご指定口座へ入金します。",
        },
      ],
    },
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: [
        "相談しやすく、",
        "進めやすいYOHJI YAMAMOTO買取。",
      ],
      intro:
        "LINEで相談してから進められるため、アーカイブ品や相場が分かりにくいアイテムも、宅配買取へ進む前に確認できます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "まず相談してから進められるため、状態や市場性に不安がある品も事前に確認できます。",
        },
        {
          title: "送料は無料",
          text:
            "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合はそのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
    faq: {
      label: "09 / FAQ",
      titleLines: [
        "YOHJI YAMAMOTO買取で、",
        "よくあるご質問。",
      ],
      items: [
        {
          question:
            "どのYOHJI YAMAMOTOアイテムを買取していますか？",
          answer:
            "YOHJI YAMAMOTO POUR HOMME、YOHJI YAMAMOTO、Y's、Y's for men、Ground Y、S'YTEを中心に、ジャケット、コート、パンツ、シャツ、ニット、セットアップ、バッグ、小物まで幅広くご相談いただけます。",
        },
        {
          question:
            "YOHJI YAMAMOTO POUR HOMMEは高く売れますか？",
          answer:
            "状態・年代・素材・シルエット・現在需要によって変動します。特にジャケット、コート、セットアップ、ワイドパンツなどは丁寧に評価します。",
        },
        {
          question:
            "Y'sやY's for menも査定できますか？",
          answer:
            "はい。Y's、Y's for menも査定対象です。廃止ラインや希少な過去作は、年代・状態・現在需要を踏まえて個別に確認します。",
        },
        {
          question:
            "Ground YやS'YTEも買取対象ですか？",
          answer:
            "はい。Ground Y、S'YTEも査定可能です。人気型、サイズ、状態、再販需要を確認して判断します。",
        },
        {
          question:
            "古いYOHJI YAMAMOTOのアーカイブも買取できますか？",
          answer:
            "はい。年代だけで一律には判断せず、シーズン背景、希少性、素材、シルエット、現在の需要を踏まえて個別に査定します。",
        },
        {
          question:
            "YOHJI YAMAMOTOの買取相場を先に知りたいです。",
          answer:
            "まずはLINEで写真をお送りください。ライン、品番、状態、サイズ、素材、現在需要を確認し、宅配買取へ進む前に大まかな方向性をご案内します。",
        },
      ],
    },
    finalCta: {
      titleLines: [
        "まずはLINEで、",
        "YOHJI YAMAMOTOの価値をご相談ください。",
      ],
      body:
        "POUR HOMME、Y's、Ground Y、S'YTE、ウールギャバ、ワイドパンツ、アーカイブ作品まで確認。\nEnclopediaが、黒と余白の価値を見て宅配買取へ丁寧につなげます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };

export default article;
